import ForgotPasswordForm from './ForgotPasswordForm.jsx';

export {ForgotPasswordForm}



// WEBPACK FOOTER //
// ./components/forgotpassword/index.js